<template>
  <v-layout column align-center>
    <v-col cols="12" class="mt-8 ml-0">
      <div id="main">
        <v-row class="ml-12 pl-12">
          <span
            class="
              mb-7
              text-right
              display-1
              font-weight-bold
              grey--text
              text--darken-1
            "
          >
            {{ $vuetify.lang.t("$vuetify.PERMISSOES") }}</span
          >
        </v-row>

        <v-row class="justify-center">
          <v-col cols="3" class="ml-0 mt-3">
            <v-row>
              <v-col cols="8" class="mt-n4 pr-0 mr-0">
                <v-row>
                  <span
                    class="
                      text-right
                      subtitle-2
                      font-weight-bold
                      grey--text
                      text--lighten-1
                    "
                  >
                    {{ $vuetify.lang.t("$vuetify.BUSCAR") }}:</span
                  >
                </v-row>
                <v-row class="mr-1">
                  <v-text-field
                    v-model.trim="searchFieldText"
                    dense
                    label="Regular"
                    :placeholder="$vuetify.lang.t('$vuetify.NOME_CAMPO')"
                    single-line
                    solo
                    append-icon="mdi-magnify"
                    @click:append="searchFields()"
                    @keypress.enter.stop.prevent="searchFields()"
                  ></v-text-field>
                </v-row>
              </v-col>
              <v-col cols="2" class="mt-1">
                <v-menu
                  transition="slide-x-transition"
                  bottom
                  right
                  v-show="!$vuetify.breakpoint.xs"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="ma-2"
                      dark
                      color="blue darken-2"
                      v-on="on"
                      :x-small="$vuetify.breakpoint.xs"
                      :small="!$vuetify.breakpoint.xs"
                    >
                      {{ $vuetify.lang.t("$vuetify.ACOES") }}
                      <v-icon right dark> mdi-chevron-down </v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="showNewEditFieldDialog()">
                      <v-list-item-title>{{
                        $vuetify.lang.t("$vuetify.NOVO_CAMPO")
                      }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      :disabled="!selectedField"
                      @click="showNewEditFieldDialog(selectedField)"
                    >
                      <v-list-item-title>{{
                        $vuetify.lang.t("$vuetify.EDITAR_CAMPO")
                      }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="showBatchDialog = true">
                      <v-list-item-title>{{
                        $vuetify.lang.t("$vuetify.EDICAO_LOTE")
                      }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      @click="showRemoveField()"
                      :disabled="!selectedField"
                    >
                      <v-list-item-title>{{
                        $vuetify.lang.t("$vuetify.REMOVER_CAMPO")
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="mt-n5">
              <v-col class="ml-n4">
                <v-lazy
                  :options="{ threshold: 0.6 }"
                  transition="slide-x-transition"
                >
                  <v-radio-group
                    v-model="selectedField"
                    v-show="fields.length > 0"
                    style="
                      overflow-y: auto;
                      max-height: 380px;
                      overflow-x: hidden;
                    "
                    class="mb-3"
                  >
                    <v-radio
                      v-for="(item, i) in fields"
                      :key="i"
                      :value="item"
                      color="blue darken-2"
                      class="font-weight-bold pl-6 pt-1"
                      @click.native="loadPermissions()"
                    >
                      <template slot="label">
                        <v-tooltip top max-width="220">
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="pa-1"
                              :class="{ 'ml-n7': $vuetify.breakpoint.xs }"
                              v-on="on"
                            >
                              <v-list-item-title
                                class="subtitle-2"
                                :class="{ caption: $vuetify.breakpoint.xs }"
                              >
                                {{ item.nome }}</v-list-item-title
                              >
                            </v-list-item-content>
                          </template>
                          <span>{{ item.descricao }}</span>
                        </v-tooltip>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-lazy>

                <v-lazy
                  :options="{ threshold: 0.6 }"
                  transition="slide-x-transition"
                >
                  <WarningPanel
                    class="ml-n6 mt-8"
                    :mobile="true"
                    :message="
                      $vuetify.lang.t('$vuetify.NENHUM_CAMPO_SELECIONADO')
                    "
                    v-show="fields.length == 0 && !isLoadingFields"
                    :small="true"
                  ></WarningPanel>
                </v-lazy>

                <v-row justify="center">
                  <v-progress-circular
                    v-if="isLoadingFields"
                    :size="30"
                    :width="4"
                    color="blue darken-2"
                    indeterminate
                    class="ml-n10 mt-6 mb-n1 text-center"
                  ></v-progress-circular>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-divider vertical class="mt-12 mb-0" :style="{ height: 28 + 'em' }">
          </v-divider>

          <v-col cols="3" class="mt-10 pt-11 ml-6 mr-6">
            <v-row v-if="selectedField" class="mt-n9">
              <TooltipButton
                :label="$vuetify.lang.t('$vuetify.SALVAR')"
                :message="$vuetify.lang.t('$vuetify.SALVAR_CAMPO')"
                :mobile="$vuetify.breakpoint.xs"
                :event="updateField"
              ></TooltipButton>
            </v-row>
            <v-row>
              <v-col class="ml-0 mt-2">
                <v-lazy
                  :options="{ threshold: 0.6 }"
                  transition="slide-x-transition"
                >
                  <WarningPanel
                    class="ml-0 mt-9"
                    :mobile="true"
                    :message="
                      !selectedField
                        ? $vuetify.lang.t('$vuetify.SELECIONE_CAMPO')
                        : selectedPermissions.length == 0
                        ? $vuetify.lang.t('$vuetify.SELECIONE_PERMISSAO')
                        : ''
                    "
                    v-show="selectedPermissions.length == 0 || !selectedField"
                    :small="true"
                  ></WarningPanel>
                </v-lazy>

                <v-lazy
                  :options="{ threshold: 0.6 }"
                  transition="slide-x-transition"
                >
                  <v-list
                    two-line
                    flat
                    class="ml-0 mt-0 pt-3 overflow-y-auto"
                    style="background: #fafafa"
                    v-if="selectedPermissions.length > 0 && selectedField"
                  >
                    <v-list-item-group>
                      <v-virtual-scroll
                        bench="0"
                        :items="selectedPermissions"
                        item-height="44"
                        class="ml-3 mt-0 overflow-y-auto"
                        :height="$vuetify.breakpoint.xs ? 170 : 380"
                      >
                        <template v-slot:default="{ item }">
                          <ButtonItem
                            :value="item.nome"
                            :action="removePermission"
                            :object="item"
                            tooltip="REMOVER_PERMISSAO"
                          >
                          </ButtonItem>
                        </template>
                      </v-virtual-scroll>
                    </v-list-item-group>
                  </v-list>
                </v-lazy>
              </v-col>
            </v-row>
          </v-col>

          <v-divider
            vertical
            class="mt-12 mb-0 mr-12"
            :style="{ height: 28 + 'em' }"
          >
          </v-divider>

          <v-col cols="3" class="">
            <v-row>
              <v-col cols="9" class="mt-0 pr-0 mr-0">
                <v-row>
                  <span
                    class="
                      text-right
                      subtitle-2
                      font-weight-bold
                      grey--text
                      text--lighten-1
                    "
                  >
                    {{ $vuetify.lang.t("$vuetify.BUSCAR") }}:</span
                  >
                </v-row>
                <v-row class="mr-1">
                  <v-text-field
                    v-model.trim="searchPermissionText"
                    dense
                    label="Regular"
                    :placeholder="$vuetify.lang.t('$vuetify.NOME_PERMISSAO')"
                    single-line
                    solo
                    append-icon="mdi-magnify"
                    @click:append="searchPermissions()"
                    @keypress.enter.stop.prevent="searchPermissions()"
                  ></v-text-field>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="mt-n3">
              <v-col class="ml-n6">
                <v-lazy
                  :options="{ threshold: 0.6 }"
                  transition="slide-x-transition"
                >
                  <v-list
                    v-show="permissions.length > 0"
                    two-line
                    flat
                    class="ml-0 mt-n5 pt-3 overflow-y-auto"
                    style="background: #fafafa"
                  >
                    <v-list-item-group multiple>
                      <v-virtual-scroll
                        bench="0"
                        :items="permissions"
                        item-height="44"
                        class="ml-3 mt-0 overflow-y-auto"
                        :height="$vuetify.breakpoint.xs ? 170 : 380"
                      >
                        <template v-slot:default="{ item }">
                          <v-list-item
                            class="mt-n0"
                            :class="{ 'ml-n3': $vuetify.breakpoint.xs }"
                          >
                            <template v-slot:default="{}">
                              <v-list-item-action>
                                <v-checkbox
                                  v-model="selectedPermissions"
                                  color="blue darken-2"
                                  dense
                                  :value="item"
                                  :disabled="!selectedField"
                                ></v-checkbox>
                              </v-list-item-action>

                              <ButtonItem
                                :value="item.nome"
                                :action="seePermissions"
                                :object="item"
                                icon="mdi-format-list-bulleted"
                                tooltip="VER_CAMPOS"
                              >
                              </ButtonItem>
                            </template>
                          </v-list-item>
                        </template>
                      </v-virtual-scroll>
                    </v-list-item-group>
                  </v-list>
                </v-lazy>

                <v-lazy
                  :options="{ threshold: 0.6 }"
                  transition="slide-x-transition"
                >
                  <WarningPanel
                    class="ml-n6 mt-8"
                    :mobile="true"
                    :message="
                      $vuetify.lang.t('$vuetify.NENHUMA_PERMISSAO_SELECIONADA')
                    "
                    v-show="permissions.length == 0 && !isLoadingPermissions"
                    :small="true"
                  ></WarningPanel>
                </v-lazy>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-progress-circular
                v-if="isLoadingPermissions"
                :size="30"
                :width="4"
                color="blue darken-2"
                indeterminate
                class="ml-n10 mt-6 mb-n1 text-center"
              ></v-progress-circular>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <NewFieldFormDialog
      :dialog="showDialog"
      :field="newField || {}"
      :close="closeDialog"
      :send="sendField"
      :showFieldAlreadyExists="showFieldAlreadyExists"
    ></NewFieldFormDialog>

    <InfoDialog
      :close="closeShowRemoveDialog"
      icon="mdi-close-circle"
      :message="
        $vuetify.lang.t(
          '$vuetify.TEM_CERTEZA_REMOVER_CAMPO',
          selectedField ? selectedField.nome : ''
        )
      "
      :dialog="showRemoveDialog"
      color="blue darken-2"
      :showAction="true"
      :actionFunction="removeField"
      :actionButtonName="$vuetify.lang.t('$vuetify.REMOVER')"
    ></InfoDialog>

    <InfoDialog
      :close="closeSaveDialog"
      icon="mdi-checkbox-marked-circle"
      :message="
        $vuetify.lang.t(
          '$vuetify.CAMPO_SALVO_COM_SUCESSO',
          selectedField ? selectedField.nome : ''
        )
      "
      :dialog="showSaveDialog"
      color="blue darken-2"
    ></InfoDialog>

    <ListDialog
      :close="closePermissionDialog"
      :list="groupPermissions"
      :title="selectedGroup.nome"
      :dialog="showPermissionDialog"
    ></ListDialog>

    <FieldBatchDialog
      :dialog="showBatchDialog"
      :close="closeBatchDialog"
      :send="sendFields"
      :isLoading="isLoadingBatch"
      url="/campo/busca"
      :noEntityMassage="$vuetify.lang.t('NENHUM_CAMPO_ENCONTRADO')"
      :noSelectedMessage="$vuetify.lang.t('NENHUM_CAMPO_SELECIONADO')"
    ></FieldBatchDialog>
  </v-layout>
</template>

<script>
import WarningPanel from "../components/panels/WarningPanel";
import TooltipButton from "../components/TooltipButton";
import NewFieldFormDialog from "../components/dialogs/NewFieldFormDialog";
import InfoDialog from "../components/dialogs/InfoDialog";
import ButtonItem from "../components/ButtonItem";
import FieldBatchDialog from "../components/dialogs/FieldBatchDialog";
import ListDialog from "../components/dialogs/ListDialog";

export default {
  components: {
    WarningPanel,
    TooltipButton,
    NewFieldFormDialog,
    InfoDialog,
    ButtonItem,
    FieldBatchDialog,
    ListDialog,
  },
  methods: {
    closePermissionDialog(){
      this.showPermissionDialog = false;
    },
    seePermissions(group){

      this.selectedGroup = group;
      this.showPermissionDialog = true;
      this.$get('/campo/busca/permissao', {
        permissionId: group.id,
      }).then((response) => {
        this.groupPermissions = response.data.map(permission => permission.nome).sort();
      })

    },
    sendFields(fields, permissions) {
      if (!permissions || permissions.length == 0) {
        return;
      }

      fields.forEach((f) => (f.permissoes = f.permissoes.concat(permissions)));

      this.isLoadingBatch = true;
      this.$post("/campo/saveAll", fields).then((response) => {
        if (!response.data) {
          return;
        }

        this.isLoadingBatch = false;
        this.closeBatchDialog();
        this.fields = response.data;
        this.selectedField = undefined;
        this.$root.$emit("invalidateFields");
      });
    },
    closeBatchDialog() {
      this.showBatchDialog = false;
    },
    closeSaveDialog() {
      this.showSaveDialog = false;
    },
    removePermission(permission) {
      for (var index in this.selectedPermissions) {
        if (this.selectedPermissions[index].id == permission.id)
          this.selectedPermissions.splice(index, 1);
      }
    },
    loadPermissions() {
      this.selectedPermissions = Object.assign(
        [],
        this.selectedField.permissoes
      );
    },
    removeField() {
      this.$post("/campo/remove", this.selectedField).then(() => {
        for (var index in this.fields) {
          if (this.fields[index].id == this.selectedField.id)
            this.fields.splice(index, 1);
        }

        this.selectedField = undefined;
      });
    },
    closeShowRemoveDialog() {
      this.showRemoveDialog = false;
    },
    showRemoveField() {
      this.showRemoveDialog = true;
    },
    hasEmptyFields(field) {
      return !field.nome || !field.descricao;
    },
    updateField() {
      this.selectedField.permissoes = this.selectedPermissions;
      this.$post("/campo/save", this.selectedField).then((response) => {
        if (!response.data) {
          return;
        }

        this.showSaveDialog = true;
      });
    },
    sendField(field) {
      if (this.hasEmptyFields(field)) {
        return;
      }

      var id = field.id;

      this.showFieldAlreadyExists = false;
      this.isLoading = true;

      this.$post("/campo/save", field).then((response) => {
        if (!response.data) {
          this.showFieldAlreadyExists = true;
          return;
        }

        if (!id) {
          setTimeout(() => this.fields.unshift(response.data), 650);
        } else {
          this.fields.forEach((f) => {
            if (f.id == id) {
              f.nome = field.nome;
              f.descricao = field.descricao;
            }
          });
        }

        this.$root.$emit("invalidateFields");
        this.isLoading = false;
        this.showDialog = false;
      });
    },
    showNewEditFieldDialog(selectedField) {
      if (!selectedField) this.newField = {};
      else this.newField = Object.assign({}, this.selectedField);
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    searchFields() {
      this.fields = [];
      this.selectedPermissions = [];
      this.isLoadingFields = true;

      this.$get("/campo/busca", {
        searchText: this.searchFieldText,
      }).then((response) => {
        if (response && response.data.length == 0) {
          this.noResult = true;
        }

        this.fields = this.fields.concat(response.data);
        this.isLoadingFields = false;
      });
    },
    searchPermissions() {
      this.permissions = [];
      this.isLoadingPermissions = true;

      this.$get("/permissao/busca", {
        searchText: this.searchPermissionText,
      }).then((response) => {
        if (response && response.data.length == 0) {
          this.noResult = true;
        }

        this.permissions = this.permissions.concat(response.data);
        this.isLoadingPermissions = false;
      });
    },
  },
  data: () => ({
    isLoadingFields: false,
    isLoadingPermissions: false,
    noResult: false,
    searchFieldText: "",
    searchPermissionText: "",
    fields: [],
    permissions: [],
    showDialog: false,
    selectedField: undefined,
    selectedPermission: undefined,
    selectedPermissions: [],
    showFieldAlreadyExists: false,
    showRemoveDialog: false,
    newField: undefined,
    showSaveDialog: false,
    showBatchDialog: false,
    isLoadingBatch: false,
    groupPermissions: [],
    selectedGroup: {},
    showPermissionDialog: false,
  }),
  created: function () {
    this.isLoadingFields = true;
    this.$get("/campo/busca", { searchText: "" }).then((response) => {
      this.fields = response.data;
      this.isLoadingFields = false;
    });

    this.isLoadingPermissions = true;
    this.$get("/permissao/busca", { searchText: "" }).then((response) => {
      this.permissions = response.data;
      this.isLoadingPermissions = false;
    });
  },
};
</script>
